import React from "react";

// Material Imports
import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import TextareaAutosize from "@mui/material/TextareaAutosize";

import { DatePicker } from "@mui/x-date-pickers";

import dayjs from "dayjs";

const useStyles = makeStyles((theme) => ({
  textField: {
    margin: "0 10px",
    width: "33%",
    fontSize: 12,
    background: theme.palette.secondary.contrastText,
  },
}));

export default function Notes(props) {
  const classes = useStyles();
  const [notes, setNotes] = React.useState("");
  const [billingDate, setBillingDate] = React.useState(null);
  const [billingCode, setBillingCode] = React.useState("");
  const [billingDiagnosis, setBillingDiagnosis] = React.useState("");

  return (
    <div
      style={{
        padding: 20,
        backgroundColor: "rgba(142, 157, 176, 0.1)",
        boxSizing: "border-box",
        height: "100%",
        color: "rgba(0, 0, 0, 0.54)",
      }}
    >
      <div style={{ display: "flex", alignItems: "start" }}>
        <SpeakerNotesIcon />
        <span style={{ marginLeft: 10 }}>Report Notes</span>
      </div>
      <div>
        <TextareaAutosize
          className="view-pdf__textarea"
          aria-label="empty textarea"
          placeholder="Write notes here"
          onChange={(e) => setNotes(e.target.value)}
          value={notes}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: "10px",
        }}
      >
        <DatePicker
          className={classes.textField}
          margin="none"
          id="billable_date"
          label="Billing Date"
          format="MM/DD/YYYY"
          value={billingDate ? dayjs(billingDate) : null}
          KeyboardButtonProps={{
            "aria-label": "pick date",
          }}
          autoOk
          onChange={(date) => {
            setBillingDate(date);
          }}
          slotProps={{
            textField: {
              fullWidth: true,
            },
          }}
        />
        <TextField
          label="Billing Code"
          value={billingCode}
          variant="outlined"
          className={classes.textField}
          onChange={(e) => {
            setBillingCode(e.target.value);
          }}
        />
        <TextField
          label="Billing Date"
          variant="outlined"
          value={billingDiagnosis}
          className={classes.textField}
          onChange={(e) => {
            setBillingDiagnosis(e.target.value);
          }}
        />
      </div>
    </div>
  );
}
